import { render, staticRenderFns } from "./MilkTable.vue?vue&type=template&id=2034df6a&scoped=true"
import script from "./MilkTable.vue?vue&type=script&lang=js"
export * from "./MilkTable.vue?vue&type=script&lang=js"
import style0 from "./MilkTable.vue?vue&type=style&index=0&id=2034df6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034df6a",
  null
  
)

export default component.exports